module.exports = __webpack_public_path__ + "static/media/swimmy-creation.9e6155b3.png";